import React, { useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { ComboCohortAddComponent } from "./component";
import { toastr } from "react-redux-toastr";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ComboCohortAddContainer = (props) => {
  const { comboId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [cohortId, setCohortId] = useState("");
  const [vmIdOption, setVmIdOption] = useState("all");
  const [error, setError] = useState({
    cohortId: "",
    vmId: "",
  });
  
  const [vmId, setVmId] = useState("");

  const handleApply = () => {
   
    const newErrors = {};
  
    
    if (!cohortId) {
      newErrors.cohortId = "Enter Cohort ID";
    }
  
   
    if (vmIdOption === "selectedOnly" && (!vmId || vmId.trim() === "")) {
      newErrors.vmId = "Please enter VM IDs";
    }
  
   
    if (Object.keys(newErrors).length > 0) {
      setError(newErrors); 
      return; 
    }
  
    
    setError({});
  
    setLoading(true);
  
    const payload = {
      is_overridden: vmIdOption === "selectedOnly",
      ...(vmIdOption === "selectedOnly" && {
        vm_ids: vmId
          .split(",")
          .map((id) => parseInt(id.trim()))
          .filter(Boolean), 
      }),
    };
  
    
    props.getDataFromAPI(
      `/partner/api/v2/combo/${comboId}/cohort/${cohortId}`,
      "PUT",
      payload,
      (response) => {
        setLoading(false);
        toast.success("Cohort updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        navigate(-1);
      },
      (err) => {
        setLoading(false);
        toastr.error(`${err?.status?.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      },
      true
    );
  };
  
  

  return (
    <>
      <ComboCohortAddComponent
        loading={loading}
        handleApply={handleApply}
        cohortId={cohortId}
        setCohortId={setCohortId}
        vmIdOption={vmIdOption}
        setVmIdOption={setVmIdOption}
        vmId={vmId}
        setVmId={setVmId}
        error={error}
        setError={setError}
      />
    </>
  );
};

function mapStateToProps({ props }) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(ComboCohortAddContainer);
